package com.essntl.features.client.ui.allclients

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getPaginationData
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.domain.repository.ClientRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AllClientsViewModel(
    private val clientRepository: ClientRepository,
    private val state: MutableStateFlow<AllClientsState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    init {
        getNextClientsPage()
    }

    fun onEvent(event: AllClientsEvent) {
        when (event) {
            is AllClientsEvent.LoadClients -> getNextClientsPage(
                client = event.client,
                refresh = event.refresh,
            )

            is AllClientsEvent.SearchClient -> {
                state.value = state.value.copy(
                    getAllClients = PaginationState(query = event.query),
                )
                getNextClientsPage()
            }
        }
    }

    private fun getNextClientsPage(
        client: ClientModel? = null,
        refresh: Boolean = false,
        query: String = state.value.getAllClients.query,
    ) {
        if (client != null) {

            val newClient = state.value.getAllClients.data.find {
                it.id == client.id
            }

            if (newClient != null) {
                // Edit client
                state.update {
                    it.copy(
                        getAllClients = it.getAllClients.copy(
                            data = it.getAllClients.data.map { ta ->
                                if (ta.id == client.id) {
                                    client
                                } else {
                                    ta
                                }
                            },
                        ),
                    )
                }
            } else {
                // Add new client
                onEvent(AllClientsEvent.SearchClient(""))
            }
        } else {

            if (refresh)
                state.update {
                    it.copy(
                        getAllClients = PaginationState(query = query),
                    )
                }

            getPaginationData(
                getData = {
                    val nextPage = state.value.getAllClients.loadedPages + 1L
                    clientRepository.getAll(page = nextPage, query = query)
                },
                getState = { state.value.getAllClients },
                setState = {
                    state.value = state.value.copy(getAllClients = it)
                },
            )
        }
    }
}